import { Field, TextOutput } from 'Components/Core';
import { IFieldProps } from 'Components/Core/Field/types';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetBatchUpdateImportSourceField } from 'Components/WorksheetBatchUpdate/Core';
import { WorksheetBatchUpdateWorksheetFieldSection } from 'Components/WorksheetBatchUpdate/types';
import QestIds from 'Components/Worksheets/QestIds';
import React from 'react';
import { WorksheetBatchUpdateWorksheetField } from '../..';
export const AsRelativeCompactionWorksheetSections: {
  [name: string]: WorksheetBatchUpdateWorksheetFieldSection;
} = {
  CompactionData: {
    heading: 'Compaction Data',
  },
};

export const AsRelativeCompactionWorksheetFields: {
  [name: string]: WorksheetBatchUpdateWorksheetField;
} = {
  'data.FieldResults.AssociatedCompactionData.ImportedTest': {
    displayComponent: React.createElement(
      withInjectedProps<IFieldProps>(({ value, ...otherFieldProps }) => (
        <Field
          {...otherFieldProps}
          input={<TextOutput />}
          value={value?.Results?.ReferenceId ?? value?.Sample?.SampleId}
          label={'Laboratory Density Sample ID'}
        />
      ))
    ),
    entryComponent: (
      <WorksheetBatchUpdateImportSourceField
        importPropertyName={'CommonTestLoader'}
        queryParams={{
          testMethodIds: `${QestIds.maximumDryDensity.AS_1289_5_1_1.rev2017},${QestIds.maximumDryDensity.AS_1289_5_2_1.rev2017}`,
        }}
      />
    ),
    alsoSets: ['data.FieldResults.AssociatedCompactionData.AssociatedTestType'],
    displayFieldsWhenEntered: [
      'data.Results.MaximumDryDensity',
      'data.Results.OptimumMoistureContent',
      'data.Results.DryDensityRatio',
      'data.Results.MoistureRatio',
      'data.Results.MoistureVariation',
    ],

    isImportSource: true,
    section: 'CompactionData',
  },
  'data.Results.MaximumDryDensity': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Results.OptimumMoistureContent': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Results.DryDensityRatio': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Results.MoistureRatio': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Results.MoistureVariation': {
    displayComponent: <Field input={<TextOutput />} />,
  },
};

export default AsRelativeCompactionWorksheetFields;
